/* eslint-disable react/no-danger */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/Accordion.module.scss';
import { CreateTicket, handleImpressionsTrack, modifyEcs } from '../../api';
import { useAuth } from '../../contexts/auth';
import { clickTracker, hasJdMartVertical, empList } from '../../lib/common';

export default function ModifyEcs({ setShowData, activeIndex, projectId, faqObj }) {
  const reasons = {
    'Change Monthly Plan': 1,
    'Change Bank Details': 2,
  };
  const [authState] = useAuth();
  const { selectedBusiness } = authState;
  const [selectedReason, setSelectedReason] = useState(0);
  const queryParams = new URLSearchParams(window.location.search);
  const [resultMessage, setResultMessage] = useState('');
  const [isDisable, setIsDisable] = useState(true);
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio'));
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));

  useEffect(() => {
    if (activeIndex !== -1) {
      setResultMessage('');
    }
  }, [activeIndex]);
  useEffect(() => {
    if (selectedReason) {
      setIsDisable(false);
    }
  }, [selectedReason]);
  const modifyEcsSubmit = async () => {
    if (projectId === 'csportal') {
      const reqbody = {
        pid: queryParams.get('pid') || selectedBusiness.parentid,
        city: queryParams.get('city') || selectedBusiness.data_city,
        mtype: reasons[selectedReason],
      };
      const res = await modifyEcs(reqbody);
      if (res.errorCode === 0) {
        setResultMessage(res.result);
        setShowData(true);
      }
      setSelectedReason(0);
      setIsDisable(true);
    } else {
      try {
        const params = {
          vertical: hasJdMartVertical() ? 'JD MART CORPORATE' : 'RETENTION',
          category: 'CS',
          ticket_creator: 'BUSINESS',
          nm: selectedBusinessGenio?.contractPersonName || selectedBusinessGenio?.companyName || '',
          created_by: profile?.mobile || '',
          mob: selectedBusinessGenio?.mobile || '',
          issue_type: faqObj?.issue || '',
          issue_sub_type: faqObj?.subIssue || '',
          issue_comment: selectedReason || '',
          document: [],
          city: selectedBusinessGenio?.city || '',
          oid: '',
          orderid: '',
          docid: selectedBusinessGenio?.docId || '',
          src: 'sales-genio',
          src_typ: empList.includes(profile.empCode)
            ? 'Genio – Market Research'
            : selectedBusinessGenio?.concern === 'client'
              ? 'client'
              : 'internal',
          src_nm: profile?.full_name || '',
          src_mob: profile?.mobile || '',
          _type: 'ecsModifyGenio',
          projectId: 'genio',
          parentId: selectedBusinessGenio?.parentId || '',
          compnm: selectedBusinessGenio?.companyName || '',
          ...(projectId === 'genio' && {
            agent_mngr_id: profile?.reporteeCode,
            agent_id: profile?.empCode,
          }),
        };
        const res = await CreateTicket(params);
        if (res) {
          setResultMessage(res?.result?.msg);
        }
      } catch (err) {
        console.log('ERROR in ecs modify submit', err);
      }
    }
  };
  return (
    <div>
      {!resultMessage ? (
        <div>
          <div className="font12 fw600 color111 mb-12">Please select the details you wish to modify</div>
          <ul className={`${styles.Accordion__Items} `}>
            {Object.keys(reasons).map((item, idx) => {
              return (
                <li className={`${styles.Accordion__Item}`}>
                  <label htmlFor={`modify_ecs_checkbox_${idx}`} className={`${styles.Accordion__Checkbox__Lable}`}>
                    <input
                      id={`modify_ecs_checkbox_${idx}`}
                      className={`${styles.Accordion__Checkbox__Input} `}
                      type="radio"
                      name="sidcity_radio"
                      onChange={async () => {
                        setSelectedReason(item);
                        if (reasons[item] === 1) await clickTracker(`FAQ_modify_plan`, `ecs_FAQ_modify`);
                        else await clickTracker(`FAQ_modify_bank`, `ecs_FAQ_modify`);
                      }}
                    />
                    <span className={`${styles.Accordion__Checkbox__Icon} csicon `} />
                    <span
                      className={` ${styles.Accordion__Checkbox__Text} font12 fw400 color111`}
                      style={{ marginTop: '1px' }}
                    >
                      {item}
                    </span>
                  </label>
                </li>
              );
            })}
          </ul>
          <button
            type="button"
            className={`${styles.Accordion__Contant__Button} blue_whitefill_animate font14 fw600 color007 mt-20`}
            style={{
              backgroundColor: `${!isDisable ? '#0076d7' : '#CCCCCC'}`,
              border: `1px solid ${isDisable ? '#E0E0E0' : '#CCCCCC'}`,
              transitionProperty: 'background-color, background-image, border-color, box-shadow',
              transition: 'all 0.8s',
              color: `#FFFFFF`,
            }}
            disabled={isDisable}
            onClick={async () => {
              await clickTracker(`FAQ_modify_proceed`, `ecs_FAQ_modify`);
              if (projectId === 'csportal') {
                const liVal = 'click';
                const liTrd = `cta_proceed`;
                const faqTypeVal = '';
                const othersData = [];
                const llTrd = `issue_ecs`;
                const llTrdInside = `faq_${faqObj?.faqKey}`;
                await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
              }
              modifyEcsSubmit();
            }}
          >
            Proceed
          </button>
        </div>
      ) : (
        <div
          className={`${styles.Accordion__DotItem__Text} font12 fw400 color777`}
          dangerouslySetInnerHTML={{ __html: resultMessage || '' }}
        />
      )}
    </div>
  );
}
ModifyEcs.propTypes = {
  setShowData: PropTypes.func,
  activeIndex: PropTypes.number,
  projectId: PropTypes.string,
  faqObj: PropTypes.object,
};
